import { z } from "zod";

export const reviewServiceSchema = z.object({
  rating: z.number({ required_error: "RATING_REQUIRED" }),
  comment: z.string({ required_error: "FEEDBACK_REQUIRED" }).min(1, "FEEDBACK_REQUIRED"),
});

export type ReviewServiceData = z.infer<typeof reviewServiceSchema>;
